/* @ngInject */
function StatusBadgeController ($scope, $rootScope, $translate) {
  const possibleStatus = {
    WAITING_PRE_APPROVAL: {
      color: 'yellow',
      text: $translate.instant('approve')
    },
    WAITING_RESPONSE: {
      color: 'yellow',
      text: $translate.instant('waitingApproval')
    },
    PROGRESS: {
      color: 'blue',
      text: $translate.instant('inProgress')
    },
    REVIEW: {
      color: 'purple',
      text: $translate.instant('underReview')
    },
    DONE: {
      color: 'green',
      text: $translate.instant('done')
    },
    REJECTED: {
      color: 'red',
      text: $translate.instant('rejected')
    },
    WAITING_ADM_ADJUST: {
      color: 'orange',
      text: $translate.instant('adjustments')
    },
    WAITING_USER_ADJUST: {
      color: 'orange',
      text: $translate.instant('adjustments')
    },
    INBOX: {
      color: 'yellow',
      text: $rootScope.isUser() ? $translate.instant('inboxStatusRequest') : $translate.instant('inboxStatus')
    },
    APPROVED: {
      color: 'green',
      text: $translate.instant('approved')
    }
  }
  const api = {
    _decideTagColor,
    _decideTagText
  }
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.getTagColor = api._decideTagColor
  $scope.getTagText = api._decideTagText

  function _decideTagColor (status) {
    return possibleStatus[status]?.color
  }

  function _decideTagText (status) {
    if ($rootScope.isUser() && !$rootScope.oUser.isGroupOwner && status === 'WAITING_PRE_APPROVAL') {
      return possibleStatus.WAITING_RESPONSE.text
    }

    return possibleStatus[status]?.text
  }
}

export { StatusBadgeController }
